import { useExperimentTreatmentWithoutReporting } from '../experiments';
import { useCurrentSessionUserField } from '../session';

type UseIsInformationBarrierEnabled = () => boolean;
export const useIsInformationBarrierEnabled: UseIsInformationBarrierEnabled = () => {
  const isNetworkAdmin = !!useCurrentSessionUserField('isNetworkAdmin');
  const isVerifiedNetworkAdmin = !!useCurrentSessionUserField('isVerifiedNetworkAdmin');

  const isInformationBarrierEnabled = useExperimentTreatmentWithoutReporting('InformationBarriersPhase0') === true;

  return isInformationBarrierEnabled && isNetworkAdmin && isVerifiedNetworkAdmin;
};
